import Svg, { Ellipse, Path } from 'react-native-svg';
import { TIllustrationProps } from './types';

export const IllustrationPeopleCloud = ({
  width = 300,
  height = 300,
  className,
}: TIllustrationProps) => (
  <Svg
    width={width}
    height={height}
    fill="none"
    className={className}
    viewBox="0 0 300 300"
  >
    <Path
      fill="#fff"
      d="M251.567 158.077c0-25.343-20.57-45.885-45.946-45.885h-8.935C189.38 90.013 168.474 74 143.818 74c-30.735 0-55.648 24.88-55.648 55.575 0 1.78.09 3.538.253 5.272a34.941 34.941 0 0 0-5.593-.454C63.594 134.398 48 149.967 48 169.178c0 19.21 15.594 34.784 34.83 34.784h123.933v-.014c24.847-.603 44.808-20.912 44.808-45.871h-.004Z"
    />
    <Path
      fill="#FDBD9A"
      fillRule="evenodd"
      d="M163.315 203.744c-.473-9.137-3.754-18.17-9.936-25.517-14.433-17.16-39.199-18.608-55.31-3.238-8.052 7.682-12.42 18.105-12.975 28.755h78.221Z"
      clipRule="evenodd"
    />
    <Ellipse cx="124.422" cy="140.328" fill="#FDBD9A" rx="19.883" ry="21.09" />
    <Path
      fill="#FF8D78"
      fillRule="evenodd"
      d="M192.157 203.744c-.473-9.137-3.755-18.17-9.936-25.517-14.433-17.16-39.199-18.608-55.309-3.238-8.054 7.682-12.421 18.105-12.976 28.755h78.221Z"
      clipRule="evenodd"
    />
    <Ellipse cx="153.266" cy="140.328" fill="#FF8D78" rx="19.883" ry="21.09" />
    <Path
      fill="#FE7165"
      fillRule="evenodd"
      d="M222.526 203.744c-.473-9.137-3.755-18.17-9.936-25.517-14.433-17.16-39.199-18.608-55.309-3.238-8.053 7.682-12.421 18.105-12.976 28.755h78.221Z"
      clipRule="evenodd"
    />
    <Ellipse cx="183.635" cy="140.328" fill="#FE7165" rx="19.883" ry="21.09" />
    <Path
      fill="#C4E8E4"
      d="M247.95 200.764c0-13.938-11.337-25.236-25.322-25.236h-4.924c-4.026-12.197-15.548-21.004-29.136-21.004-16.938 0-30.668 13.683-30.668 30.565 0 .979.049 1.946.139 2.899a19.314 19.314 0 0 0-3.082-.249c-10.601.003-19.195 8.565-19.195 19.131 0 10.565 8.594 19.13 19.195 19.13h68.301v-.008c13.693-.331 24.694-11.501 24.694-25.228h-.002Z"
    />
  </Svg>
);
